/// <reference path="./theme.d.ts" />
import {createTheme} from '@mui/material/styles';

export const theme = createTheme({
  palette: {
    primary: {
      main: '#1B263B', // Navy Blue - primary background, headers
    },
    secondary: {
      main: '#FF6F59', // Bright Coral - CTAs and highlight elements
    },
    success: {
      main: '#90BE6D', // Lime Green - success states, accents, progress emphasis
    },
    grey: {
      100: '#CED4DA', // Soft Grey - neutral sections, dividers, text backgrounds
      200: '#E9ECEF',
      300: '#DEE2E6',
      400: '#CED4DA',
      500: '#ADB5BD',
      600: '#6C757D',
      700: '#495057',
      800: '#343A40',
      900: '#212529',
    },
    text: {
      primary: '#1B263B',
      secondary: '#6C757D',
    },
    background: {
      default: '#FFFFFF',
      paper: '#FFFFFF',
    },
  },
  typography: {
    fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
    h1: {
      fontWeight: 700,
      fontSize: '3rem',
      lineHeight: 1.2,
      color: '#1B263B',
    },
    h2: {
      fontWeight: 700,
      fontSize: '2.5rem',
      lineHeight: 1.3,
      color: '#1B263B',
    },
    h3: {
      fontWeight: 600,
      fontSize: '2rem',
      lineHeight: 1.4,
      color: '#1B263B',
    },
    h4: {
      fontWeight: 600,
      fontSize: '1.5rem',
      lineHeight: 1.4,
      color: '#1B263B',
    },
    h5: {
      fontWeight: 600,
      fontSize: '1.25rem',
      lineHeight: 1.4,
      color: '#1B263B',
    },
    h6: {
      fontWeight: 600,
      fontSize: '1rem',
      lineHeight: 1.4,
      color: '#1B263B',
    },
    body1: {
      fontSize: '1rem',
      lineHeight: 1.6,
      color: '#6C757D',
    },
    body2: {
      fontSize: '0.875rem',
      lineHeight: 1.6,
      color: '#6C757D',
    },
    button: {
      fontWeight: 600,
      textTransform: 'none',
    },
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        '*': {
          boxSizing: 'border-box',
          padding: 0,
          margin: 0,
        },
        html: {
          maxWidth: '100vw',
          overflowX: 'hidden',
        },
        body: {
          maxWidth: '100vw',
          overflowX: 'hidden',
          overflowY: 'hidden',
        },
        a: {
          color: 'inherit',
          textDecoration: 'none',
        },
      },
    },

    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: '8px',
          padding: '12px 24px',
          fontSize: '1rem',
          fontWeight: 600,
        },
        contained: {
          boxShadow: 'none',
          '&:hover': {
            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
          },
        },
        outlined: {
          borderWidth: '2px',
          '&:hover': {
            borderWidth: '2px',
          },
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: '#FFFFFF',
          boxShadow: '0 2px 8px rgba(27, 38, 59, 0.1)',
        },
      },
    },
    // Custom styled components theme overrides
    CcBodyContainer: {
      styleOverrides: {
        root: {
          // Default styles for BodyContainer component
          // Can be overridden here or via sx prop
        },
      },
    },
    CcContentContainer: {
      styleOverrides: {
        root: {
          // Default styles for ContentContainer component
          // Can be overridden here or via sx prop
        },
      },
    },
    SearchField: {
      styleOverrides: {
        root: {
          // Default styles for SearchField component
          // Can be overridden here or via sx prop
        },
      },
    },
    ToggleFilter: {
      styleOverrides: {
        root: {
          // Default styles for ToggleFilter component
          // Can be overridden here or via sx prop
        },
        label: {
          // Default styles for ToggleFilter label
          // Can be overridden here or via sx prop
        },
        chipsContainer: {
          // Default styles for ToggleFilter chips container
          // Can be overridden here or via sx prop
        },
      },
    },
  },
});
